import React from "react"

class Reviews extends React.Component{
    render(){
        return(
            <div className="col render">
                <span className="dashboard-logo">REVIEWS</span>
            </div>
        )
    }
}

export default Reviews